
            window.addEventListener("load", function () {
                initJQuery(function () {
                    if (typeof $ == "undefined") {
                        $ = jQuery;
                    }
                    var setColor = setInterval(function () {
                        if ($(".chat-bubble").length >0) {
                            var chat_bubble = $(".chat-bubble")[0]
                            $(chat_bubble).css("inset", "auto auto 20px 16px")
                            var bubble_div = $(chat_bubble).contents().find(".bu1")[0]
                            $(bubble_div).css("background-color", "#F79343")
                            var chat_content = $(".chat-content")[0]
                            
                            $(chat_content).css("inset", "auto auto 90px 10px")
                            setTimeout(function () {
                                var content_header = $(chat_content).contents().find(".b1")[0]
                                $(content_header).css("background-color", "#F79343")
                                var title = $(chat_content).contents().find(".b121")[0]
                                $(title).css("color", "#fafafa")
                                $(title).text("Gratis advies nodig? ")
                                $(title).prop("title", "Gratis advies nodig? ");
                                var intro = $(chat_content).contents().find(".b122")[0]
                                $(intro).css("color", "#fafafa")
                                $(intro).text("Stuur een bericht en we helpen je graag verder :)")
                                $(intro).prop("title", "Stuur een bericht en we helpen je graag verder :)");
                            }, 500)
                            document.getElementsByClassName('chat-bubble')[0].style.opacity = 1
                            clearInterval(setColor);
                        }
                    }, 500);
                })
            });
            
            function initJQuery(e) {
                var t;
                "undefined" == typeof jQuery ? ((t = document.createElement("SCRIPT")).src = "https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js", t.type = "text/javascript", t.onload = e, document.head.appendChild(t)) : e()
            }
        